var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMood5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.42,733.97c-6.19,0-12.4-.16-18.62-.48-94.7-4.86-181.83-46.31-245.36-116.7C44.93,546.39,12.62,455.47,17.48,360.77c4.86-94.7,46.31-181.83,116.7-245.35C204.58,51.9,295.5,19.59,390.2,24.45c94.7,4.86,181.83,46.31,245.36,116.7,63.52,70.4,95.83,161.32,90.97,256.01-4.86,94.7-46.31,181.83-116.7,245.36-65.77,59.35-149.45,91.45-237.39,91.45ZM371.62,60.94c-78.78,0-153.75,28.76-212.67,81.92-63.07,56.91-100.2,134.97-104.55,219.8-4.35,84.83,24.59,166.28,81.5,229.35,56.91,63.07,134.97,100.2,219.8,104.55,5.57.29,11.14.43,16.68.43,78.79,0,153.75-28.75,212.67-81.92,63.07-56.91,100.2-134.97,104.55-219.8,8.99-175.13-126.17-324.91-301.3-333.9h0c-5.58-.29-11.14-.43-16.68-.43Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 224.63,
    cy: 374.33,
    r: 41.77
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.36,
    cy: 374.33,
    r: 41.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.7,572.13c67.91-.77,123.25-49.53,131.92-93.66,1.23-6.47-3.66-12.45-10.25-12.49h-243.35c-6.59.04-11.47,6.02-10.25,12.49,8.67,44.13,64.01,92.9,131.92,93.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood5);
export default __webpack_public_path__ + "static/media/mood5.b0f756a7709c55a950cd6b8a21528f5b.svg";
export { ForwardRef as ReactComponent };